export class LoginViewModel {
  email!: string;
  password!: string;
  returnUrl: string | undefined;
}
